/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ---------------------------------------------------------------------------
 * Deep category menu: expand the branch of the current collection on load and
 * bring it into view. Works purely from the rendered DOM, so it functions even
 * when the parent_collection metafield is not populated yet.
 * ------------------------------------------------------------------------- */
(function () {
  function deepNavExpandActive() {
    document.querySelectorAll('.deep-nav-menu').forEach(function (menu) {
      var current = menu.querySelector('[aria-current="page"]');
      if (!current) return;

      var el = current.parentElement;
      while (el && el !== menu) {
        if (el.classList && el.classList.contains('collection__filter-collapsible')) {
          el.setAttribute('aria-hidden', 'false');
          el.style.height = 'auto';
          var btn = document.querySelector('[aria-controls="' + el.id + '"]');
          if (btn) {
            btn.setAttribute('aria-expanded', 'true');
          }
        }
        el = el.parentElement;
      }

      // Keep the current item in view inside a scrollable menu without moving the page.
      var scroller = menu.closest('.mobile-menu__panel, .drawer__inner, .card');
      if (scroller && scroller.scrollHeight > scroller.clientHeight) {
        var offset = current.offsetTop - scroller.offsetTop - 80;
        if (offset > 0) {
          scroller.scrollTop = offset;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deepNavExpandActive);
  } else {
    deepNavExpandActive();
  }

  // Theme editor re-renders sections without a page load — re-apply then too.
  document.addEventListener('shopify:section:load', deepNavExpandActive);
})();

/* Product inquiries and the mobile purchase bar. */
(function () {
  function isMiniCartOpen() {
    var miniCart = document.getElementById('mini-cart');
    return miniCart && miniCart.getAttribute('aria-hidden') === 'false';
  }

  // Two different moments to appear, because the two layouts read differently.
  // On a phone the buy box scrolls away almost immediately and the bar is the
  // only way back to it. On a wide screen the buy box sits in its own column
  // and stays in view for a long time, so showing the bar as soon as it leaves
  // would put a floating island over a page that still shows the real button -
  // there it waits until the reader is past the description and its Technische
  // Daten table, i.e. done reading and ready to decide.
  var wideViewport = window.matchMedia('(min-width: 641px)');

  function barShouldShow(bar) {
    if (wideViewport.matches && bar.dataset.watchesDescription === 'true') {
      return bar.dataset.pastDescription === 'true';
    }
    return bar.dataset.shouldShow === 'true';
  }

  function syncMobileProductBar(bar) {
    var shouldShow = barShouldShow(bar) && !isMiniCartOpen();

    bar.classList.toggle('is-visible', shouldShow);
    bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    bar.toggleAttribute('inert', !shouldShow);
  }

  function syncMobileProductBars() {
    document.querySelectorAll('[data-mobile-product-bar]').forEach(syncMobileProductBar);
  }

  function initMiniCartObserver() {
    var miniCart = document.getElementById('mini-cart');
    if (!miniCart || miniCart.dataset.mobileProductBarObserver === 'true') return;

    miniCart.dataset.mobileProductBarObserver = 'true';
    new MutationObserver(syncMobileProductBars).observe(miniCart, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  // The inquiry card is permanently on the page, so a trigger no longer opens
  // anything: it scrolls to the card, records which button was used and puts
  // the cursor in the email field. Nothing to close, and nothing to suspend -
  // the purchase bar keeps its own visibility rule.
  function openInquiry(trigger) {
    var id = trigger.getAttribute('aria-controls');
    var inquiry = id ? document.getElementById(id) : null;
    if (!inquiry) return;

    var inquiryType = trigger.getAttribute('data-inquiry-type') || '';
    var typeInput = inquiry.querySelector('[data-product-inquiry-type]');
    var heading = inquiry.querySelector('[data-product-inquiry-heading]');
    if (typeInput) typeInput.value = inquiryType;
    if (heading && inquiryType) heading.textContent = inquiryType;

    // The card is hidden on phones until asked for - it is a tall form and it
    // pushed the rest of the page down for everyone who never wanted it.
    inquiry.classList.add('is-open');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    inquiry.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'center' });
    window.setTimeout(function () {
      var email = inquiry.querySelector('input[type="email"]');
      if (email) email.focus({ preventScroll: true });
    }, reduceMotion ? 0 : 350);
  }

  function initMobileProductBars() {
    document.querySelectorAll('[data-mobile-product-bar]:not([data-mobile-product-bar-init])').forEach(function (bar) {
      var section = bar.closest('[data-section-type="product"]');
      var buyBox = section && section.querySelector('.product-form__payment-container');
      if (!buyBox || !('IntersectionObserver' in window)) return;

      bar.dataset.mobileProductBarInit = 'true';
      new IntersectionObserver(function (entries) {
        bar.dataset.shouldShow = entries[0].isIntersecting ? 'false' : 'true';
        syncMobileProductBar(bar);
      }, { threshold: 0.2 }).observe(buyBox);

      // The sentinel sits at the very end of the description block. Growing the
      // observer root 260px past the bottom of the window makes it register
      // while the end of the Technische Daten table is still being read, so the
      // bar arrives as that table runs out rather than well after it.
      var sentinel = section.querySelector('[data-product-bar-sentinel]');
      if (sentinel) {
        bar.dataset.watchesDescription = 'true';
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var reached = entry.isIntersecting || entry.boundingClientRect.top < 0;
          bar.dataset.pastDescription = reached ? 'true' : 'false';
          syncMobileProductBar(bar);
        }, { rootMargin: '0px 0px 260px 0px', threshold: 0 }).observe(sentinel);
      }
    });

    initMiniCartObserver();
    syncMobileProductBars();
  }

  if (wideViewport.addEventListener) {
    wideViewport.addEventListener('change', syncMobileProductBars);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-product-inquiry-trigger]');
    if (trigger) {
      event.preventDefault();
      openInquiry(trigger);
      return;
    }

  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileProductBars);
  } else {
    initMobileProductBars();
  }

  document.addEventListener('shopify:section:load', initMobileProductBars);
  document.addEventListener('variant:changed', function () {
    window.setTimeout(initMobileProductBars, 500);
  });
})();

/* ---------------------------------------------------------------------------
 * Two-pane mega menu (deep-mega-menu.liquid): hovering an item in the left
 * rail swaps the right pane to that category's branch.
 *
 * The level-3/4 grids are NOT in the page HTML; each pane with children carries
 * a [data-deep-mega-src] container and the grid comes from
 * {collection.url}?section_id=deep-mega-pane (sections/deep-mega-pane.liquid,
 * Section Rendering API).
 *
 * Opening a menu loads the pane in view and its neighbours (two below, one
 * above), so moving along the rail shows them at once. Never a whole branch:
 * every pane is a server render. A pane that is still on its way shows skeleton
 * rows (only the pane in view). A grid fetched once stays in sessionStorage for
 * the tab, so later pages show it without a request; nothing personal is in
 * there. Change CACHE when the markup of deep-mega-pane changes. In-flight
 * requests are deduplicated and a failed fetch is retried on the next hover.
 *
 * Panes intentionally swap on pointer hover only (not on focus): keyboard
 * users tab through the rail links, each a real link to its category, and
 * swapping panes on focus would make every pane except the last one
 * unreachable.
 * ------------------------------------------------------------------------- */
(function () {
  var CACHE = 'sk-pane1:';
  var paneRequests = {};

  function cacheGet(url) {
    try { return window.sessionStorage.getItem(CACHE + url); } catch (error) { return null; }
  }

  function cacheSet(url, html) {
    try { window.sessionStorage.setItem(CACHE + url, html); } catch (error) {}
  }

  function paneUrl(container) {
    var src = container.getAttribute('data-deep-mega-src');
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'section_id=deep-mega-pane';
  }

  function fill(container, html) {
    container.innerHTML = html;
    container.dataset.deepMegaLoaded = 'true';
  }

  // Only if the list really keeps the visitor waiting: on a normal connection it
  // arrives in about 130 ms and rows flashing that briefly just look like a glitch.
  function showSkeleton(container) {
    var skeleton = container.querySelector('.sk-pane-loading');
    if (!skeleton || skeleton.dataset.skPending) return;
    skeleton.dataset.skPending = 'true';
    window.setTimeout(function () {
      delete skeleton.dataset.skPending;
      if (!skeleton.isConnected || container.dataset.deepMegaFailed === 'true') return;
      if (!skeleton.firstChild) {
        skeleton.innerHTML = new Array((parseInt(skeleton.getAttribute('data-sk-rows'), 10) || 8) + 1).join('<i></i>');
      }
      skeleton.hidden = false;
    }, 300);
  }

  function loadPane(pane) {
    var container = pane && pane.querySelector('[data-deep-mega-src]');
    if (!container || container.dataset.deepMegaLoaded === 'true') return;

    var url = paneUrl(container);
    var cached = cacheGet(url);
    if (cached !== null) {
      fill(container, cached);
      return;
    }

    delete container.dataset.deepMegaFailed;
    if (pane.classList.contains('is-active')) showSkeleton(container);
    if (paneRequests[url]) return;

    paneRequests[url] = window.fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('deep-mega-pane HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var grid = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-deep-mega-grid]');
        var markup = grid ? grid.outerHTML : '';
        cacheSet(url, markup);
        fill(container, markup);
      })
      .catch(function () {
        delete paneRequests[url]; // allow a retry on the next hover
        container.dataset.deepMegaFailed = 'true';
        var skeleton = container.querySelector('.sk-pane-loading');
        if (skeleton) skeleton.hidden = true;
      });
  }

  function nearestWithList(pane, property, count) {
    var found = [];
    var el = pane[property];
    while (el && found.length < count) {
      if (el.querySelector('[data-deep-mega-src]')) found.push(el);
      el = el[property];
    }
    return found;
  }

  function loadPaneAndNeighbours(pane) {
    if (!pane) return;
    loadPane(pane);
    if (pane.dataset.deepMegaNear) return;
    pane.dataset.deepMegaNear = 'true';
    nearestWithList(pane, 'nextElementSibling', 2).concat(nearestWithList(pane, 'previousElementSibling', 1)).forEach(loadPane);
  }

  function deepMegaMenu() {
    document.querySelectorAll('.deep-mega').forEach(function (menu) {
      if (menu.dataset.deepMegaInit) return;
      menu.dataset.deepMegaInit = 'true';

      function loadActive() {
        loadPaneAndNeighbours(menu.querySelector('.deep-mega__pane.is-active'));
      }

      // Primary trigger: the header nav link that opens this mega menu.
      // (The menu element's own mouseenter only fires once the pointer moves
      // INTO the open dropdown, which is too late for the first pane.)
      var megaRoot = menu.closest('.mega-menu');
      if (megaRoot && megaRoot.id) {
        var navTrigger = document.querySelector('[aria-controls="' + megaRoot.id + '"]');
        if (navTrigger) {
          navTrigger.addEventListener('mouseenter', loadActive);
          navTrigger.addEventListener('focus', loadActive);
        }
      }

      // Fallbacks: entering or tabbing into the menu itself.
      menu.addEventListener('mouseenter', loadActive);
      menu.addEventListener('focusin', loadActive);

      menu.querySelectorAll('[data-deep-mega-target]').forEach(function (railLink) {
        railLink.addEventListener('mouseenter', function () {
          var targetId = railLink.getAttribute('data-deep-mega-target');

          menu.querySelectorAll('.deep-mega__rail-link').forEach(function (el) {
            el.classList.toggle('is-active', el === railLink);
          });

          menu.querySelectorAll('.deep-mega__pane').forEach(function (pane) {
            var isActive = pane.id === targetId;
            pane.classList.toggle('is-active', isActive);
            if (isActive) {
              pane.removeAttribute('aria-hidden');
            } else {
              pane.setAttribute('aria-hidden', 'true');
            }
          });

          loadPaneAndNeighbours(document.getElementById(targetId));
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deepMegaMenu);
  } else {
    deepMegaMenu();
  }

  document.addEventListener('shopify:section:load', deepMegaMenu);
})();

/* ---------------------------------------------------------------------------
 * Search category picker (sections/header.liquid)
 * The native <select> keeps driving the theme's search JS, but its option list
 * is drawn by the OS and cannot be themed. We render a themed picker next to it
 * and mirror every choice back into the select (dispatching `change`, which is
 * what the search component listens for).
 * ------------------------------------------------------------------------- */
(function () {
  function searchTypePicker(root) {
    (root || document).querySelectorAll('.search-bar__filter--themed').forEach(function (wrapper) {
      if (wrapper.dataset.stpInit === 'true') return;
      wrapper.dataset.stpInit = 'true';

      var toggle = wrapper.querySelector('[data-search-type-toggle]');
      var picker = wrapper.querySelector('[data-search-type-picker]');
      var label = wrapper.querySelector('[data-search-type-label]');
      var select = wrapper.querySelector('#search-product-type');
      if (!toggle || !picker || !label || !select) return;

      function setOpen(open) {
        picker.setAttribute('aria-hidden', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        wrapper.classList.toggle('is-open', open);
      }

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(picker.getAttribute('aria-hidden') === 'true');
      });

      var closeButton = wrapper.querySelector('[data-search-type-close]');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          setOpen(false);
          toggle.focus();
        });
      }

      wrapper.querySelectorAll('[data-search-type-value]').forEach(function (choice) {
        choice.addEventListener('click', function () {
          var value = choice.getAttribute('data-search-type-value');

          select.value = value;
          /* the theme's search component reacts to `change`, not to clicks */
          select.dispatchEvent(new Event('change', { bubbles: true }));

          label.textContent = choice.textContent.trim();
          wrapper.querySelectorAll('[data-search-type-value]').forEach(function (el) {
            el.classList.toggle('is-selected', el === choice);
          });

          setOpen(false);
          toggle.focus();
        });
      });

      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target)) setOpen(false);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && picker.getAttribute('aria-hidden') === 'false') {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { searchTypePicker(document); });
  } else {
    searchTypePicker(document);
  }

  document.addEventListener('shopify:section:load', function (e) { searchTypePicker(e.target); });
})();

/* ---------------------------------------------------------------------------
 * Restock notification modal (snippets/restock-notify.liquid).
 * The "Benachrichtigen" button on a sold-out card opens the modal through the
 * theme's ModalManager (data-action="open-modal"); this only copies the
 * product into the form. After the contact form posts, Shopify returns to
 * the page with #restock-notify and the modal reopens in its thank-you state.
 *
 * form.posted_successfully? is not used for this: Shopify sets it for every
 * contact form on the page. On a product page that would also flip the
 * product inquiry card into its own "sent" message, so there the page is
 * reloaded once without the contact_posted flag and the thank-you state is
 * carried across in sessionStorage.
 * ------------------------------------------------------------------------- */
(function () {
  var MODAL_ID = 'modal-restock-notify';
  var RETURN_HASH = '#restock-notify';
  var FORM_HASH = '#restock-notify-form';
  var SENT_KEY = 'medRestockNotifySent';

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function store(key, value) {
    try {
      if (value === null) {
        window.sessionStorage.removeItem(key);
      } else {
        window.sessionStorage.setItem(key, value);
      }
    } catch (error) {}
  }

  function read(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function cleanSearch() {
    return window.location.search
      .replace(/([?&])contact_posted=[^&]*&?/, '$1')
      .replace(/[?&]$/, '');
  }

  function setProduct(modal, title, sku, url) {
    modal.querySelector('[data-restock-field="title"]').value = title;
    modal.querySelector('[data-restock-field="sku"]').value = sku;
    modal.querySelector('[data-restock-field="url"]').value = url;
    modal.querySelector('[data-restock-product]').textContent = title;
    modal.querySelector('[data-restock-sku]').textContent = sku;
    modal.querySelector('[data-restock-sku-line]').hidden = !sku;
    modal.querySelector('[data-restock-item]').hidden = !title;
  }

  function fill(trigger) {
    var modal = getModal();
    if (!modal) return;

    setProduct(
      modal,
      trigger.getAttribute('data-product-title') || '',
      trigger.getAttribute('data-product-sku') || '',
      trigger.getAttribute('data-product-url') || ''
    );
    modal.classList.remove('is-success');
    modal.querySelector('[data-restock-return]').value = window.location.pathname + cleanSearch() + RETURN_HASH;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(function () {
      var email = modal.querySelector('input[type="email"]');
      if (email) email.focus({ preventScroll: true });
    }, reduceMotion ? 50 : 260);
  }

  // Open through ModalManager so overlay, scroll lock, Escape and focus trap
  // behave exactly like the theme's own modals.
  function openModal() {
    var opener = document.createElement('button');
    opener.type = 'button';
    opener.hidden = true;
    opener.setAttribute('data-action', 'open-modal');
    opener.setAttribute('aria-controls', MODAL_ID);
    document.body.appendChild(opener);
    opener.click();
    opener.remove();
  }

  function showSuccess(modal, title) {
    modal.querySelector('[data-restock-product]').textContent = title;
    modal.querySelector('[data-restock-sku-line]').hidden = true;
    modal.querySelector('[data-restock-item]').hidden = !title;
    modal.classList.add('is-success');
    openModal();
  }

  function onLoad() {
    var modal = getModal();
    if (!modal) return;

    var hash = window.location.hash;
    var returned = hash === RETURN_HASH || (hash === FORM_HASH && /[?&]contact_posted=true/.test(window.location.search));

    if (returned) {
      var title = read(SENT_KEY + 'Title') || '';
      var cleanUrl = window.location.pathname + cleanSearch();

      if (document.querySelector('[data-product-inquiry]') && /[?&]contact_posted=/.test(window.location.search)) {
        store(SENT_KEY, '1');
        window.location.replace(cleanUrl);
        return;
      }

      try {
        window.history.replaceState(null, '', cleanUrl);
      } catch (error) {}
      store(SENT_KEY, null);
      store(SENT_KEY + 'Title', null);
      showSuccess(modal, title);
      return;
    }

    if (read(SENT_KEY)) {
      var sentTitle = read(SENT_KEY + 'Title') || '';
      store(SENT_KEY, null);
      store(SENT_KEY + 'Title', null);
      showSuccess(modal, sentTitle);
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-restock-notify]');
    if (trigger) fill(trigger);
  });

  document.addEventListener('submit', function (event) {
    if (!event.target.closest || !event.target.closest('#' + MODAL_ID)) return;
    var titleField = event.target.querySelector('[data-restock-field="title"]');
    store(SENT_KEY + 'Title', titleField ? titleField.value : '');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }
})();

/* ---------------------------------------------------------------------------
 * Reveal on scroll (custom-medical.css §33).
 * Every candidate is observed once. The first IntersectionObserver report
 * decides: an element that starts below the fold is parked as "pending"
 * (hidden, 22px low) and rises in when it reaches the viewport; anything
 * already on screen, above it or off to the side is left alone, so nothing
 * that was painted ever disappears again. Elements entering together are
 * staggered by 70ms (capped). Items in a horizontal scroller reveal as one
 * group, so swiping a carousel later does not fade cards in one by one.
 * Content added later (collection filters, recommendations, recently
 * viewed) is picked up by a debounced MutationObserver.
 * ------------------------------------------------------------------------- */
(function () {
  if (!('IntersectionObserver' in window) || !window.matchMedia) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CANDIDATES = [
    '.section__header',
    '.collection-item',
    '.about-card__media',
    '.about-card__body',
    '.promo-block',
    '.product-item',
    '.article-item',
    '.medical-blog__header',
    '.section--text-centered > .container',
    '.product-block-list__item--description > .card',
    '.product-block-list__item--content > .card',
    '.usp-card',
    '.spb-card',
    '.contact-layout__media',
    '.contact-layout__card',
    '.text-with-icons__item'
  ].join(',');

  // Never inside overlays, the header, the sticky buy box or the hero and
  // trust bar (those have their own opening animation). Product cards on
  // collection pages appear without motion (merchant's choice, 2026-10-22).
  var EXCLUDED = '.modal, .drawer, .popover, .mini-cart, .header, .card--sticky, .iib, .trust-bar, .product-inquiry-card, .template-collection .product-item, [data-reveal-skip]';
  var GROUP = '.scroller, .product-list--scrollable, .text-with-icons';
  var STEP = 70;
  var MAX_STEPS = 5;
  var observer;

  function inScope(el) {
    return (el.closest('main') || el.classList.contains('text-with-icons__item')) && !el.closest(EXCLUDED);
  }

  function reveal(list) {
    list.sort(function (a, b) {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    list.forEach(function (el, i) {
      observer.unobserve(el);
      el.style.setProperty('--reveal-delay', Math.min(i, MAX_STEPS) * STEP + 'ms');
      el.setAttribute('data-reveal-state', 'in');
    });
  }

  observer = new IntersectionObserver(function (entries) {
    var batch = [];

    entries.forEach(function (entry) {
      var el = entry.target;
      var state = el.getAttribute('data-reveal-state');

      if (state === 'observing') {
        var viewportHeight = entry.rootBounds ? entry.rootBounds.height : window.innerHeight;
        if (!entry.isIntersecting && entry.boundingClientRect.top >= viewportHeight) {
          el.setAttribute('data-reveal-state', 'pending');
        } else {
          el.setAttribute('data-reveal-state', 'done');
          observer.unobserve(el);
        }
        return;
      }

      if (state === 'pending' && entry.isIntersecting && batch.indexOf(el) === -1) {
        batch.push(el);
        var group = el.closest(GROUP);
        if (group) {
          group.querySelectorAll('[data-reveal-state="pending"]').forEach(function (member) {
            if (batch.indexOf(member) === -1) batch.push(member);
          });
        }
      }
    });

    if (batch.length) reveal(batch);
  }, { threshold: 0 });

  function scan(root) {
    (root || document).querySelectorAll(CANDIDATES).forEach(function (el) {
      if (el.hasAttribute('data-reveal-state') || !inScope(el)) return;
      // One animated layer per spot: skip anything inside an element that is
      // already handled (e.g. a card inside an animated container).
      var parent = el.parentElement && el.parentElement.closest('[data-reveal-state]');
      if (parent) return;
      el.setAttribute('data-reveal-state', 'observing');
      observer.observe(el);
    });
  }

  // A finished animation no longer holds the element: "done" carries no
  // animation, so a later display toggle does not replay it.
  document.addEventListener('animationend', function (event) {
    var el = event.target;
    if (event.animationName === 'med-rise' && el.getAttribute && el.getAttribute('data-reveal-state') === 'in') {
      el.setAttribute('data-reveal-state', 'done');
      el.style.removeProperty('--reveal-delay');
    }
  });

  var pendingScan = null;
  function scheduleScan() {
    if (pendingScan) return;
    pendingScan = window.setTimeout(function () {
      pendingScan = null;
      scan(document);
    }, 80);
  }

  function start() {
    scan(document);
    var main = document.querySelector('main');
    if (main && 'MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) {
            scheduleScan();
            return;
          }
        }
      }).observe(main, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleScan);
})();

/* ---------------------------------------------------------------------------
 * Product photo ahead of the click.
 * The theme already fetches a product's page when the pointer rests on its link
 * or a finger lands on it (instant.page), but the photo only started once that
 * page was read, so the page opened with an empty gallery for a moment. The same
 * moment now also fetches the photo, in the size the product page will ask for:
 * same widths and sizes as snippets/product-gallery.liquid, so the browser picks
 * the same file and has it ready for the first paint. Skipped on data-saving and
 * very slow connections, and capped per page so sweeping over a grid stays cheap.
 * ------------------------------------------------------------------------- */
(function () {
  var connection = navigator.connection;
  if (connection && (connection.saveData || /2g/.test(connection.effectiveType || ''))) return;

  var SIZES = '(max-width: 999px) 100vw, 60vw';
  var WIDTHS = [400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1500, 1800];
  var HOVER_DELAY = 65; // the same pause instant.page waits before it fetches
  var LIMIT = 24;
  var fetched = {};
  var inFlight = [];
  var pendingCard = null;
  var timer = null;

  function fetchPhoto(card) {
    var img = card.querySelector('.product-item__primary-image');
    if (!img || !img.src || inFlight.length >= LIMIT) return;

    var base = img.src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    if (fetched[base]) return;
    fetched[base] = true;

    var full = parseInt(img.getAttribute('width'), 10) || 1800;
    var join = base.indexOf('?') === -1 ? '?' : '&';
    var candidates = WIDTHS.filter(function (w) { return w < full; }).concat(full).map(function (w) {
      return base + join + 'width=' + w + ' ' + w + 'w';
    });

    var photo = new Image();
    photo.sizes = SIZES;
    photo.srcset = candidates.join(', ');
    inFlight.push(photo); // a reference, so the download is not dropped midway
  }

  document.addEventListener('mouseover', function (event) {
    var card = event.target.closest && event.target.closest('.product-item');
    if (card === pendingCard) return;
    window.clearTimeout(timer);
    pendingCard = card;
    if (card) timer = window.setTimeout(function () { fetchPhoto(card); }, HOVER_DELAY);
  }, { passive: true });

  document.addEventListener('touchstart', function (event) {
    var card = event.target.closest && event.target.closest('.product-item');
    if (card) fetchPhoto(card);
  }, { passive: true });
})();

/* Trust bar badges (§34 in custom-medical.css): one play per hover. The class stays on until the
   animation ends, so a quick pass of the pointer never cuts it off halfway. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)').matches) return;

  document.addEventListener('mouseover', function (event) {
    var badge = event.target.closest && event.target.closest('.trust-bar__item');
    if (badge && !badge.contains(event.relatedTarget)) badge.classList.add('is-playing');
  }, { passive: true });

  document.addEventListener('animationend', function (event) {
    var badge = event.target.closest && event.target.closest('.trust-bar__item');
    if (badge) badge.classList.remove('is-playing');
  }, { passive: true });
})();
